import Logo from "../images/Logo_Black.svg"

export const LogoText = ({ admin }: { admin?: boolean }) => (
  <div>
    <img src={Logo} alt="logo" className="inline-block max-h-8" />
  </div>
)
